<template>
  <div>
    <el-table :data="list">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sectionNum" label="区间值"> </el-table-column>
      <el-table-column prop="coefficient" label="系数"> </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="查看">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-view"
              @click="viewDetail(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="删除">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-delete"
              @click="removeItem(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';

export default {
  name: 'pledgeList',
  computed: {
    ...mapState('pledgeCoefficient', ['totalCount', 'pagination']),
    ...mapGetters('pledgeCoefficient', ['list'])
  },
  components: {
    Pagination,
    Detail
  },
  methods: {
    ...mapActions('pledgeCoefficient', ['remove']),
    ...mapMutations('pledgeCoefficient', ['setDetail']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    viewDetail(item) {
      this.setDetail(item);
    },
    removeItem(row) {
      this.$confirm('确认要删除么？', '提示', {
        type: 'warning'
      }).then(() => {
        this.remove(row.id).then(() => {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.$emit('refresh', { page: 1 });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
